export default __webpack_public_path__ + "static/byron_filming-a4d4b09afa26ffa6ef3ffebe2fb976e3.jpg";